export const getParam = (name, query = window.location.search) => {
  const params = new URLSearchParams(query);
  return params.get(name);
};

export const addParam = (name, val, query = window.location.search) => {
  const params = new URLSearchParams(query);
  params.append(name, val);

  return params;
};

export const deleteParam = (name, query = window.location.search) => {
  const params = new URLSearchParams(query);
  params.delete(name);

  return params;
};